import { Pipe, PipeTransform } from '@angular/core';
import { Moment } from 'moment';

/**
 * Formats a resolved [start, end] month range into a compact, uppercased label:
 *   - same month:  "JUN 2026"
 *   - same year:   "JAN-JUN 2026"
 *   - year cross:  "JAN 2025 - JUN 2026"
 *
 * Intended for the selected-period label on service metric cards. Pair with
 * FiltersService.getSelectedPeriodRange() to resolve the range from the selected period.
 *
 * Takes the resolved range object (not the period string) so a changed 'Custom' range
 * produces a new reference and this pure pipe recomputes — keying on the period string
 * would let a stale label survive a custom-range change.
 */
@Pipe({
  name: 'monthYearRange',
  standalone: false,
})
export class MonthYearRangePipe implements PipeTransform {
  transform(range: { start: Moment; end: Moment } | undefined | null): string {
    if (!range) {
      return '';
    }

    const { start, end } = range;
    const sameYear = start.year() === end.year();
    const sameMonth = sameYear && start.month() === end.month();

    let label: string;
    if (sameMonth) {
      label = start.format('MMM YYYY');
    } else if (sameYear) {
      label = `${start.format('MMM')}-${end.format('MMM')} ${end.format('YYYY')}`;
    } else {
      label = `${start.format('MMM YYYY')}-${end.format('MMM YYYY')}`;
    }

    return label.toUpperCase();
  }
}
